import React, { useState } from 'react';
import { getBaseUrl } from '../config';
import { useToast } from './Toast';

const LoadData = ({ onTablesUpdate }) => {
    const [tableName, setTableName] = useState('');
    const [filePath, setFilePath] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const showToast = useToast();

    const handleLoadData = async () => {
        if (!tableName || !filePath) {
            showToast('Please provide both table name and file path.', 'warning');
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch(`${getBaseUrl()}/ops/load-data`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    table: tableName,
                    file: filePath,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showToast(data.message || 'Data loaded successfully!', 'success');
                // Trigger refresh of the tables list
                if (onTablesUpdate) {
                    onTablesUpdate();
                }
            } else {
                showToast(`Error: ${data.message || 'Failed to load data'}`, 'error');
            }
        } catch (error) {
            showToast(`Error: ${error.message}`, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <h2 className="title is-3">Load Data</h2>
            <p className="subtitle">Import data from external sources</p>
            <div className="content">
                <div className="field">
                    <label className="label">Table Name</label>
                    <div className="control">
                        <input
                            className="input"
                            type="text"
                            placeholder="Enter table name..."
                            value={tableName}
                            onChange={(e) => setTableName(e.target.value)}
                        />
                    </div>
                </div>
                <div className="field">
                    <label className="label">File Path</label>
                    <div className="control">
                        <input
                            className="input"
                            type="text"
                            placeholder="Enter file path..."
                            value={filePath}
                            onChange={(e) => setFilePath(e.target.value)}
                        />
                    </div>
                </div>
                <br />
                <button
                    className={`button is-success ${isLoading ? 'is-loading' : ''}`}
                    onClick={handleLoadData}
                    disabled={isLoading}
                >
                    <span className="icon">
                        <i className="bi bi-cloud-upload"></i>
                    </span>
                    <span>Load Data</span>
                </button>
            </div>
        </div>
    );
};

export default LoadData;
